import { render, staticRenderFns } from "./TrainingAfterRegisterForm.vue?vue&type=template&id=08c658aa&"
import script from "./TrainingAfterRegisterForm.vue?vue&type=script&lang=js&"
export * from "./TrainingAfterRegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports